<div class="row search-filter-header-top m-b" [hidden]="!searchFilters.title">
  <div class="col-md-6">
    <h2>{{ searchFilters.title }}</h2>
  </div>
</div>
